import { Injectable } from '@angular/core';
import * as RouteConstants from '../constants/route.constants';
import { ApiService } from './api.service';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RegionsService {
  private routeConstants = RouteConstants.REGIONS_URLS;

  constructor(private api: ApiService) {}

  getAll() {
    return this.api.get(this.routeConstants.GET_ALL);
  }

  getById(id: string) {
    let params = new HttpParams();
    params = params.set('id', id);

    return this.api.get(this.routeConstants.GET_BY_ID, params);
  }
}
